module.exports = __webpack_public_path__ + "img/9ecd6893b129c75e791a3987f5285928.png";